import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Property1Default from "../components/Property1Default";
import SizeMediumStateDefaultSt1 from "../components/SizeMediumStateDefaultSt1";
import Component1 from "../components/Component1";
import Footer from "../components/Footer";
import styles from "./Staff.module.css";

const Staff = () => {
  const navigate = useNavigate();

  const onButtonContainerClick = useCallback(() => {
    navigate("/about");
  }, [navigate]);

  const onAboutMeContainerClick = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const onAboutMeContainer1Click = useCallback(() => {
    navigate("/about");
  }, [navigate]);

  const onAboutMeContainer2Click = useCallback(() => {
    navigate("/services");
  }, [navigate]);

  return (
    <div className={styles.staff}>
      <div className={styles.header}>
        <div className={styles.container}>
          <div className={styles.medicalIconiPhysicalTherapParent}>
            <img
              className={styles.medicalIconiPhysicalTherap}
              alt=""
              src="/medicaliconiphysicaltherapy1.svg"
            />
            <div className={styles.logo}>
              <img className={styles.logo1Icon} alt="" src="/logo-1.svg" />
              <b className={styles.personal}>
                <p className={styles.jJPhysical}>{`J &J Physical`}</p>
                <p className={styles.jJPhysical}>Therapy</p>
              </b>
            </div>
          </div>
          <div className={styles.taskbaar}>
            <div className={styles.aboutMe} onClick={onAboutMeContainerClick}>
              <div className={styles.aboutMe1}>Home</div>
            </div>
            <div className={styles.aboutMe} onClick={onAboutMeContainer1Click}>
              <div className={styles.aboutMe1}>About</div>
            </div>
            <div className={styles.aboutMe} onClick={onAboutMeContainer2Click}>
              <div className={styles.aboutMe1}>Services</div>
            </div>
            <Property1Default
              sectionTitle="Our Staff"
              property1DefaultBorderRadius="15px"
              property1DefaultBackgroundColor="rgba(93, 37, 214, 0.63)"
              property1DefaultBoxShadow="0px 4px 4px rgba(0, 0, 0, 0.25)"
              property1DefaultPadding="10px"
              property1DefaultBoxSizing="border-box"
            />
          </div>
          <SizeMediumStateDefaultSt1
            linkText="Contact Us"
            showDownloadIcon={false}
            sizeMediumStateDefaultStCursor="pointer"
            sizeMediumStateDefaultStBorder="unset"
            sizeMediumStateDefaultStBackgroundColor="#000"
            sizeMediumStateDefaultStHeight="56px"
            sizeMediumStateDefaultStJustifyContent="center"
            sizeMediumStateDefaultStPadding="var(--padding-base) var(--padding-xl)"
            sizeMediumStateDefaultStBoxSizing="border-box"
            sizeMediumStateDefaultStWidth="unset"
            sizeMediumStateDefaultStZIndex="unset"
            resumeDisplay="inline-block"
            onButtonContainerClick={onButtonContainerClick}
          />
        </div>
      </div>
      <div className={styles.testimonial}>
        <div className={styles.frameParent}>
          <div className={styles.frameGroup}>
            <div className={styles.ourStaffWrapper}>
              <b className={styles.ourStaff}>Our Staff</b>
            </div>
            <div className={styles.yearsOfExperienceQuisLoreWrapper}>
              <div className={styles.yearsOfExperienceContainer}>
                <p className={styles.jJPhysical}>
                  20 years of experience. Quis lorem consequat est varius nulla
                  imperdiet pulvinar. Faucibus nibh mi leo fames tortor ultrices
                  felis.
                </p>
                <p className={styles.jJPhysical}>&nbsp;</p>
                <p className={styles.jJPhysical}>
                  20 years of experience. Quis lorem consequat est varius nulla
                  imperdiet pulvinar. Faucibus nibh mi leo fames tortor ultrices
                  felis.
                </p>
              </div>
            </div>
          </div>
          <div className={styles.frameContainer}>
            <div className={styles.groupParent}>
              <img className={styles.frameChild} alt="" src="/group-2.svg" />
              <div className={styles.frameItem} />
              <img className={styles.frameChild} alt="" src="/group-11.svg" />
              <img className={styles.frameChild} alt="" src="/group-11.svg" />
            </div>
            <div className={styles.rectangleWrapper}>
              <img
                className={styles.rectangleIcon}
                alt=""
                src="/rectangle-14@2x.png"
              />
            </div>
          </div>
        </div>
      </div>
      <Component1
        contentText="Quis lorem consequat est varius nulla imperdiet pulvinar. Faucibus nibh mi leo fames tortor ultrices felis. Facilisis nunc hac sed lectus "
        component1Height="253px"
        quisLoremConsequatContainTextAlign="center"
      />
      <div className={styles.frameDiv}>
        <div className={styles.drJohnBerryQuisLoremConseParent}>
          <div className={styles.drJohnBerryContainer}>
            <p className={styles.jJPhysical}>
              <b>DR John Berry</b>
            </p>
            <p className={styles.jJPhysical}>
              <b>&nbsp;</b>
            </p>
            <p className={styles.jJPhysical}>
              Quis lorem consequat est varius nulla imperdiet pulvinar. Faucibus
              nibh mi leo fames tortor ultrices felis. Facilisis nunc hac sed
              lectus vehicula massa dui faucibus lacus. Euismod orci quis mauris
              purus accumsan justo nunc velit sagittis.
            </p>
          </div>
          <img
            className={styles.frameChild1}
            alt=""
            src="/rectangle-4@2x.png"
          />
        </div>
        <div className={styles.frameParent1}>
          <div className={styles.rectangleContainer}>
            <img
              className={styles.frameChild2}
              alt=""
              src="/rectangle-5@2x.png"
            />
          </div>
          <div className={styles.drJanetBerryQuisLoremConsWrapper}>
            <div className={styles.drJanetBerryContainer}>
              <p className={styles.jJPhysical}>
                <b>DR Janet Berry</b>
              </p>
              <p className={styles.jJPhysical}>
                <b>&nbsp;</b>
              </p>
              <p className={styles.jJPhysical}>
                Quis lorem consequat est varius nulla imperdiet pulvinar.
                Faucibus nibh mi leo fames tortor ultrices felis. Facilisis nunc
                hac sed lectus vehicula massa dui faucibus lacus. Euismod orci
                quis mauris purus accumsan justo nunc velit sagittis.
              </p>
            </div>
          </div>
        </div>
        <div className={styles.frameParent2}>
          <div className={styles.drMihomidAlifQuisLoremConWrapper}>
            <div className={styles.drJanetBerryContainer}>
              <p className={styles.jJPhysical}>
                <b>DR Mihomid Alif</b>
              </p>
              <p className={styles.jJPhysical}>
                <b>&nbsp;</b>
              </p>
              <p className={styles.jJPhysical}>
                Quis lorem consequat est varius nulla imperdiet pulvinar.
                Faucibus nibh mi leo fames tortor ultrices felis. Facilisis nunc
                hac sed lectus vehicula massa dui faucibus lacus. Euismod orci
                quis mauris purus accumsan justo nunc velit sagittis.
              </p>
            </div>
          </div>
          <div className={styles.rectangleFrame}>
            <img
              className={styles.frameChild3}
              alt=""
              src="/rectangle-11@2x.png"
            />
          </div>
        </div>
        <div className={styles.frameParent3}>
          <div className={styles.rectangleWrapper1}>
            <img
              className={styles.frameChild4}
              alt=""
              src="/rectangle-12@2x.png"
            />
          </div>
          <div className={styles.alexisPikeQuisLoremConsequWrapper}>
            <div className={styles.drJanetBerryContainer}>
              <p className={styles.jJPhysical}>
                <b>Alexis Pike</b>
              </p>
              <p className={styles.jJPhysical}>
                <b>&nbsp;</b>
              </p>
              <p className={styles.jJPhysical}>
                Quis lorem consequat est varius nulla imperdiet pulvinar.
                Faucibus nibh mi leo fames tortor ultrices felis. Facilisis nunc
                hac sed lectus vehicula massa dui faucibus lacus. Euismod orci
                quis mauris purus accumsan justo nunc velit sagittis.
              </p>
            </div>
          </div>
        </div>
        <div className={styles.frameParent4}>
          <div className={styles.juneSmithQuisLoremConsequaWrapper}>
            <div className={styles.drJanetBerryContainer}>
              <p className={styles.jJPhysical}>
                <b>June Smith</b>
              </p>
              <p className={styles.jJPhysical}>
                <b>&nbsp;</b>
              </p>
              <p
                className={styles.jJPhysical}
              >{`Quis lorem consequat est varius nulla imperdiet pulvinar. Faucibus nibh mi leo fames tortor ultrices felis. Facilisis nunc hac sed lectus vehicula massa dui faucibus lacus. `}</p>
            </div>
          </div>
          <div className={styles.rectangleWrapper2}>
            <img
              className={styles.frameChild5}
              alt=""
              src="/rectangle-18@2x.png"
            />
          </div>
        </div>
      </div>
      <div className={styles.frameParent5}>
        <div className={styles.frameParent6}>
          <div className={styles.jjPhysicalTherapyParent}>
            <div className={styles.jjPhysicalTherapyContainer}>
              <span className={styles.jjPhysical}>{`J&J Physical `}</span>
              <span>Therapy</span>
            </div>
            <div className={styles.fromPainTo}>
              From pain to progress, we're with you every step.
            </div>
          </div>
          <div className={styles.copyrightJjPhysicalTherapyWrapper}>
            <div
              className={styles.copyrightJjPhysical}
            >{` © Copyright j&j physical  therapy  inc.`}</div>
          </div>
        </div>
        <div className={styles.frameParent7}>
          <div className={styles.helpParent}>
            <div className={styles.help}>Help</div>
            <div className={styles.supportWebinarPlatformsContainer}>
              <p className={styles.jJPhysical}>Support</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Webinar Platforms</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Consult</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Video Chats</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.help}>Features</div>
            <div className={styles.ugentCareSpecialContainer}>
              <p className={styles.jJPhysical}>Ugent Care</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Special Programs</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>File Sharing</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.help}>Company</div>
            <div className={styles.aboutUsCareersContainer}>
              <p className={styles.jJPhysical}>About Us</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Careers</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>Contact Us</p>
            </div>
          </div>
          <div className={styles.helpParent}>
            <div className={styles.contactUs1}>Contact Us</div>
            <div className={styles.junesjjtherapycom1800000}>
              <p className={styles.jJPhysical}>JuneS@jjtherapy.com</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>1-800-000-000</p>
              <p className={styles.jJPhysical}>&nbsp;</p>
              <p className={styles.jJPhysical}>2384 W. Lane</p>
              <p className={styles.jJPhysical}>Somewhere, NY 10800</p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Staff;
